import { Tween } from 'create-es6-js';

const anim = {
  CSSPlugin: Tween.CSSPlugin,
  MotionGuidePlugin: Tween.MotionGuidePlugin,
  Ease: Tween.Ease,
  Timeline: Tween.Timeline,
  Tween: Tween.Tween,
};

export default anim;



// WEBPACK FOOTER //
// ./Anim/index.js